
export enum TransactionType {
	'payment' = 0,
	'credit' = 1,
	'invoice' = 2,
	'sell' = 3
}

export enum CreditStatus {
	Pending = 0,
	Paid = 1,
	Failed = 2,
	InProcess = 3,
	Canceled = 4
}

export enum TransactionStatus {
	Pending = 0,
	Paid = 1,
	Failed = 2,
	InProcess = 3,
	Canceled = 4,
	PendingSepa = 5,
	Rejected = 6
}

export enum TransactionReason {
	NewSubscription = 0,
	RenewSubscription = 1,
	UpgradeSubscription = 2
}

export interface Credit {
	id: string;
	creditNumber: string;
	communityPartnerId: string;
	totalCreditAmount: number;
	includedTax: boolean;
	donated: boolean;
	taxAmount: number;
	taxPercent: number;
	createdAt: string;
	creditStatus: number;
	isSmallCompany: boolean;
	activeAboCount: number;
	communityPartnerInfo: {
		communityPartnerId: string;
		organizationName: string;
		emailAddress: string;
		thumbnailLogo: number;
	};
	subscriptionInfo: {
		subscriptionId: string;
		businessPartnerId: string;
		startDate: string;
		endDate: string;
	};
	subscriptionPaymentReason: number;
	businessPartnerInfo: {
		businessPartnerId: string;
		firstName: string;
		lastName: string;
		organizationName: string;
		emailAddress: string;
		thumbnailLogo: number;
	};
}

export interface PaymentList {
	id: string;
	invoiceNumber: string;
	subscriptionId: string;
	businessPartnerId: string;
	planName: string;
	subscriptionPlanInfo: {
		subscriptionPlanId: {
			value: string;
		};
		subscriptionPlanCode: string;
		price: number;
		name: string;
		type: number;
		durationDays: number;
		taxPercentage: number;
	};
	communityPartnerId: string;
	communityPartnerCreditId: string;
	createdAt: string;
	lastUpdatedAt: string;
	status: number;
	reason: number;
	provider: {
		paymentReference: string;
		paymentProvider: string;
		providerStatus: string;
		description: string;
		paymentMethodInfo: {
			paymentMethodIdentifier: string;
			type: string;
			brand: string;
			last4: string;
			expMonth: string;
			expYear: string;
			email: string;
		};
	};
	price: {
		subscriptionPrice: number;
		totalAmount: number;
		taxAmount: number;
		taxPercent: number;
		discountAmount: number;
		discountPercent: number;
		subscriptionDuration: number;
		subTotal: number;
		voucherCode: string;
	};
	invoiceInfo: {
		firstName: string;
		lastName: string;
		organizationName: string;
		emailAddress: string;
		thumbnailLogo: string;
		address: {
			name: string;
			countryName: string;
			countryIso2: string;
			countryIso3: string;
			state: string;
			city: string;
			postalCode: string;
			street: string;
			houseNumber: string;
			location: {
				longitude: number;
				latitude: number;
			};
		};
		invoiceNumber: string;
		invoiceDocumentUrl: string;
	};
}

export interface InvoiceList {
	id: string;
	subscriptionId: string;
	businessPartnerId: string;
	communityPartnerId: string;
	communityPartnerCreditId: string;
	createdAt: string;
	subscriptionPlanInfo: {
		subscriptionPlanId: {
			value: string;
		};
		subscriptionPlanCode: string;
		price: number;
		name: string;
		type: number;
		durationDays: number;
		taxPercentage: number;
	};
	lastUpdatedAt: string;
	status: number;
	reason: number;
	provider: {
		paymentReference: string;
		paymentProvider: string;
		providerStatus: string;
		errorMessage: string;
		paymentMethodInfo: string;
		paymentMethodIdentifier: string;
		paymentMethodType: string;
	};
	price: {
		subscriptionPrice: number;
		totalAmount: number;
		taxAmount: number;
		taxPercent: number;
		discountAmount: number;
		discountPercent: number;
		subscriptionDuration: number;
		subTotal: number;
		voucherCode: string;
	};
	invoiceInfo: {
		firstName: string;
		lastName: string;
		organizationName: string;
		emailAddress: string;
		thumbnailLogo: string;
		address: {
			name: string;
			countryName: string;
			countryIso2: string;
			countryIso3: string;
			state: string;
			city: string;
			postalCode: string;
			street: string;
			houseNumber: string;
			location: {
				longitude: number;
				latitude: number;
			};
		};
		invoiceNumber: string;
		invoiceDocumentUrl: string;
	};
}

export interface Invoice {
	id: string;
	businessPartnerId: string;
	subscriptionId: string;
	createdAt: string;
	lastUpdatedAt: string;
	status: number;
	provider: {
		paymentReference: string;
		paymentProvider: string;
		providerStatus: string;
		errorMessage: string;
		paymentMethodInfo: string;
		paymentMethodIdentifier: string;
		paymentMethodType: string;
	};
	tenantId: string;
	price: {
		subscriptionPrice: number;
		totalAmount: number;
		taxAmount: number;
		taxPercent: number;
		discountAmount: number;
		discountPercent: number;
		subscriptionDuration: number;
		subTotal: number;
		voucherCode: string;
	};
	communityPartnerCreditId: string;
	invoiceInfo: {
		firstName: string;
		lastName: string;
		organizationName: string;
		emailAddress: string;
		thumbnailLogo: string;
		address: {
			name: string;
			countryName: string;
			countryIso2: string;
			countryIso3: string;
			state: string;
			city: string;
			postalCode: string;
			street: string;
			houseNumber: string;
			location: {
				longitude: number;
				latitude: number;
			};
		};
		invoiceNumber: string;
		invoiceDocumentUrl: string;
	};
	subscriptionPlanInfo: {
		subscriptionPlanId: {
			value: string;
		};
		subscriptionPlanCode: string;
		price: number;
		name: string;
		type: number;
		durationDays: number;
		taxPercentage: number;
	};
	reason: number;
}

export interface CreditDetails {
	id: string;
	communityPartnerId: string;
	subscriptionPaymentId: string;
	creditNumber: string;
	creditStatus: number;
	totalCreditAmount: number;
	includedTax: boolean;
	taxAmount: number;
	taxPercent: number;
	isSmallCompany: boolean;
	donated: boolean;
	createdAt: string;
	updatedAt: string;
	subscriptionPlanInfo: {
		subscriptionPlanId: any;
		subscriptionPlanCode: string;
		price: number;
		name: string;
		type: number;
		durationDays: number;
		taxPercentage: number;
	};
	commissionGroupInfo: {
		commissionGroupId: any;
		title: string;
		isActive: boolean;
		isPremium: boolean;
	};
	commissionLevelInfo: {
		commissionLevelId: any;
		title: string;
		minActiveAbo: number;
		maxActiveAbo: number;
		commissionPercent: number;
		commissionCost: number;
	};
	activeAboCount: number;
	communityPartnerInfo: {
		communityPartnerId: {
			value: string;
		};
		organizationName: string;
		emailAddress: string;
		thumbnailLogo: string;
	};
	subscriptionInfo: {
		subscriptionId: {
			value: string;
		};
		businessPartnerId: {
			value: string;
		};
		startDate: string;
		endDate: string;
	};
	subscriptionPaymentReason: number;
	businessPartnerInfo: {
		businessPartnerId: {
			value: string;
		};
		firstName: string;
		lastName: string;
		organizationName: string;
		emailAddress: string;
		thumbnailLogo: string;
	};
}